import { createFileRoute } from "@tanstack/react-router";

import NotFoundPage from "@/components/NotFoundPage";
import { signalNotFound } from "@/routing/notFoundSignal";

export const Route = createFileRoute("/_app/_dashboard/$")({
  beforeLoad: () => {
    signalNotFound();
  },
  component: NotFoundPage,
});
